export default "__VITE_ASSET__CIzNTHF9__"